// Pagina prodotto NFR — logica portata da ProductClient del vecchio sito Next.
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

// Icone (stroke, 24x24) per la scheda prodotto
const ICON = {
  cotton: '<path d="M12 3c2 2.5 2 5 0 7.5C10 8 10 5.5 12 3z"/><path d="M12 21v-8"/><path d="M12 13c-3.5 0-6-2-7-5 3.5 0 6 2 7 5zM12 13c3.5 0 6-2 7-5-3.5 0-6 2-7 5z"/>',
  weight: '<path d="M6 7h12l2 13H4z"/><path d="M9 7a3 3 0 0 1 6 0"/>',
  italy: '<path d="M4 21V4"/><path d="M4 4h5v9H4"/><path d="M9 4h5v9H9"/><path d="M14 4h5v9h-5"/>',
  hand: '<path d="M8 13V5a1.5 1.5 0 0 1 3 0v6M11 11V4a1.5 1.5 0 0 1 3 0v7M14 11V5.5a1.5 1.5 0 0 1 3 0V14a7 7 0 0 1-7 7h-.5A6.5 6.5 0 0 1 4 15l-1-3a1.5 1.5 0 0 1 2.7-1.3L8 13"/>',
  wash: '<path d="M3 7l2 12h14l2-12"/><path d="M3 7c1.5 1.5 3 1.5 4.5 0s3-1.5 4.5 0 3 1.5 4.5 0 3-1.5 4.5 0"/>',
  stitch: '<path d="M4 20 20 4"/><path d="M4 14l2 2M8 10l2 2M12 6l2 2M10 16l2 2M14 12l2 2"/>',
  pocket: '<path d="M5 4h14v9a7 7 0 0 1-14 0z"/><path d="M5 8h14"/>',
  hood: '<path d="M6 20V9a6 6 0 0 1 12 0v11"/><path d="M9 20v-6a3 3 0 0 1 6 0v6"/>',
  fleece: '<path d="M4 8c2-2 4-2 6 0s4 2 6 0 4-2 4 0M4 13c2-2 4-2 6 0s4 2 6 0 4-2 4 0M4 18c2-2 4-2 6 0s4 2 6 0 4-2 4 0"/>',
  model: '<circle cx="12" cy="5" r="2.5"/><path d="M12 8v7M8 22l4-7 4 7M7 11h10"/>',
  t30: '<path d="M3 7l2 12h14l2-12"/><text x="12" y="17" font-size="7.5" text-anchor="middle" fill="currentColor" stroke="none" font-weight="700">30°</text>',
  inside: '<path d="M8 3 4 6l2 3 2-1v13h8V8l2 1 2-3-4-3"/><path d="M10 3a2 2 0 0 0 4 0"/><path d="M9 14h6" stroke-dasharray="2 2"/>',
  nodry: '<rect x="4" y="4" width="16" height="16" rx="2"/><circle cx="12" cy="12" r="5"/><path d="M4 4l16 16"/>',
  noiron: '<path d="M4 17h16l-2-7H9a5 5 0 0 0-5 5z"/><path d="M3 5l18 14"/>',
};
const svg = (name) => `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${ICON[name]}</svg>`;

// Tabelle taglie reali (misure del capo in cm), riconosciute dall'immagine presente nella descrizione
const SIZE_CHARTS = {
  'Taglia_T-shirt': { sizes: ['XS', 'S', 'M', 'L', 'XL'], rows: [['Lunghezza', [63, 66, 69, 72, 75]], ['Larghezza', [40, 45, 50, 55, 58]]] },
  'Taglia_Hoodie': { sizes: ['XS', 'S', 'M', 'L', 'XL'], rows: [['Lunghezza', [55, 59, 65, 69, 72]], ['Larghezza', [46, 51, 55, 60, 65]]] },
  'HOODIE_Tavola_disegno': { sizes: ['XS', 'S', 'M', 'L', 'XL'], rows: [['Lunghezza', [62, 64, 66, 68, 70]], ['Larghezza', [56, 58, 60, 62, 64]]] },
  'crewtaglie': { sizes: ['S', 'M', 'L', 'XL'], rows: [['Larghezza', [52, 55, 58, 61]], ['Altezza', [68, 71, 74, 76]], ['Manica', [85, 88, 90, 93]]] },
  'SUITPANTS_Tavola_disegno': { sizes: ['XS', 'S', 'M', 'L', 'XL'], rows: [['Vita', [30, 32, 34, 36, 38]], ['Lunghezza', [103, 104, 105, 106, 107]], ['Cavallo', [23, 24, 25, 27, 28]], ['Fondo gamba', [25, 25, 26, 26, 27]]] },
};

const FIT_POS = { slim: 0, regular: 1, boxy: 2, oversized: 2.4, wide: 3 };
const FIT_NOTE = {
  slim: 'Aderente: se sei tra due taglie scegli la più grande.',
  regular: 'Vestibilità classica: prendi la tua taglia abituale.',
  boxy: 'Corta e larga: prendi la tua taglia per l\'effetto boxy, una in meno per un fit più asciutto.',
  oversized: 'Oversize: prendi la tua taglia abituale per un look ampio.',
  wide: 'Gamba ampia effetto balloon: prendi la tua taglia abituale.',
};

const DAYS = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];
const MONTHS = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];

function addBusinessDays(from, days) {
  const date = new Date(from);
  while (days > 0) {
    date.setDate(date.getDate() + 1);
    if (date.getDay() !== 0 && date.getDay() !== 6) days--;
  }
  return date;
}

function dayMonth(date) {
  return `${date.getDate()} ${MONTHS[date.getMonth()]}`;
}

function dateRange(from, to) {
  if (from.toDateString() === to.toDateString()) return dayMonth(from);
  if (from.getMonth() === to.getMonth()) return `${from.getDate()}–${dayMonth(to)}`;
  return `${dayMonth(from)} – ${dayMonth(to)}`;
}

// Spedizione 1–2 giorni lavorativi, consegna BRT Express 2–4 giorni lavorativi; dopo le 18 si parte da domani
function deliveryEstimate(cutoff = 18) {
  const now = new Date();
  const base = new Date(now);
  if (now.getHours() >= cutoff) base.setDate(base.getDate() + 1);
  const deliverMax = addBusinessDays(base, 4);
  return {
    order: dayMonth(now),
    ship: dateRange(addBusinessDays(base, 1), addBusinessDays(base, 2)),
    deliver: dateRange(addBusinessDays(base, 2), deliverMax),
    max: dayMonth(deliverMax),
    maxLong: `${DAYS[deliverMax.getDay()].toLowerCase()} ${dayMonth(deliverMax)}`,
  };
}

function formatMoney(cents, format) {
  const value = (cents / 100).toFixed(2);
  const [int, dec] = value.split('.');
  const withDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return (format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
    if (key === 'amount_with_comma_separator') return `${withDots},${dec}`;
    if (key === 'amount_no_decimals_with_comma_separator') return withDots;
    if (key === 'amount_no_decimals') return int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${int.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${dec}`;
  });
}

function isMobile() {
  return window.matchMedia('(max-width: 767px)').matches;
}

function hasPromo() {
  return document.documentElement.classList.contains('nfr-has-cart');
}

class NfrProduct extends HTMLElement {
  #abort = new AbortController();
  #qty = 1;
  #collapsed = false;
  #expanded = false;
  #drag = null;

  connectedCallback() {
    const { signal } = this.#abort;
    this.data = JSON.parse(this.querySelector('[data-product-json]').textContent);
    this.moneyFormat = this.dataset.moneyFormat;
    this.panel = this.querySelector('[data-panel]');

    this.querySelectorAll('[data-variant-picker] input[type="radio"]').forEach((input) =>
      input.addEventListener('change', () => this.#onOptionChange(), { signal })
    );
    this.querySelectorAll('[data-go]').forEach((btn) =>
      btn.addEventListener('click', () => this.#showMedia(Number(btn.dataset.go), { smooth: true }), { signal })
    );
    this.querySelector('[data-form]').addEventListener('submit', (e) => this.#add(e), { signal });
    this.querySelector('[data-sticky-add]').addEventListener('click', () => this.#add(), { signal });
    this.querySelector('[data-drag]').addEventListener('click', () => {
      if (this.#expanded) this.#setExpanded(false);
      else this.#setCollapsed(!this.#collapsed);
    }, { signal });
    this.querySelector('[data-shrink]')?.addEventListener('click', () => this.#setExpanded(false), { signal });
    this.querySelectorAll('[data-reopen]').forEach((btn) =>
      btn.addEventListener('click', () => this.#setCollapsed(false), { signal })
    );

    this.#bindImageSwipe(signal);
    this.#bindPanelSwipe(signal);
    this.#bindSticky();
    this.#guardBuyNow(signal);

    // Il prezzo -50% dipende dallo stato del carrello (classe su <html> aggiornata da nfr-global)
    new MutationObserver(() => this.#render()).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    const eta = deliveryEstimate();
    this.querySelector('[data-eta-max]').textContent = eta.max;
    this.querySelector('[data-eta-order]').textContent = eta.order;
    this.querySelector('[data-eta-ship]').textContent = eta.ship;
    this.querySelector('[data-eta-deliver]').textContent = eta.deliver;

    // Indietro: torna alla pagina precedente del sito, altrimenti alla collezione
    this.querySelector('[data-back]').addEventListener('click', (e) => {
      let sameSite = false;
      try {
        sameSite = new URL(document.referrer).origin === location.origin;
      } catch {}
      if (sameSite && history.length > 1) {
        e.preventDefault();
        history.back();
      }
    }, { signal });

    this.#renderSpec();
    this.querySelectorAll('[data-open-guide]').forEach((b) => b.addEventListener('click', () => {
      const guide = this.querySelector('[data-size-guide]');
      guide.open = true;
      guide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, { signal }));
    this.#loadRecommendations(signal);
    // All'apertura resta la prima foto (il retro); la foto della variante solo se scelta da link (?variant=)
    this.#onOptionChange({ showVariantMedia: new URL(window.location.href).searchParams.has('variant') });
  }

  disconnectedCallback() {
    this.#abort.abort();
    this.observer?.disconnect();
  }

  get #sizeInputs() {
    return [...this.querySelectorAll('[data-size-group] input[type="radio"]')];
  }

  // La taglia va scelta dal cliente: niente XS preselezionata per sbaglio
  get sizeChosen() {
    const inputs = this.#sizeInputs;
    return !inputs.length || inputs.some((i) => i.checked);
  }

  get variant() {
    const selected = this.data.options.map((_, i) => this.querySelector(`input[data-option-index="${i}"]:checked`)?.value);
    return this.data.variants.find((v) => v.options.every((o, i) => selected[i] === undefined || o === selected[i])) || this.data.variants[0];
  }

  #onOptionChange({ showVariantMedia = true } = {}) {
    const variant = this.variant;
    this.querySelectorAll('[data-variant-input]').forEach((input) => (input.value = variant.id));
    const sizeGroup = this.querySelector('[data-size-group]');
    sizeGroup?.classList.toggle('has-value', this.sizeChosen);
    if (this.sizeChosen) sizeGroup?.classList.remove('is-need');
    const need = sizeGroup?.querySelector('[data-size-need]');
    if (need) need.textContent = this.sizeChosen ? `Taglia ${this.#sizeInputs.find((i) => i.checked)?.value} ✓` : 'Scegli una taglia';
    this.data.options.forEach((_, i) => {
      const cur = this.querySelector(`[data-current-option="${i}"]`);
      if (cur) cur.textContent = variant.options[i];
    });
    this.querySelector('[data-variant-title]').textContent = variant.title === 'Default Title'
      ? this.data.vendor
      : this.sizeChosen ? variant.title : variant.options.filter((_, i) => !this.#isSizeIndex(i)).join(' / ');
    this.#markAvailability(variant);
    this.#highlightSize();
    if (showVariantMedia && variant.media_id) this.#showMedia(variant.media_id);
    else if (!this.mediaId) this.#showMedia(this.data.media[0]?.id);
    const url = new URL(window.location.href);
    if (this.sizeChosen) url.searchParams.set('variant', variant.id);
    else url.searchParams.delete('variant');
    window.history.replaceState({}, '', url);
    this.#render();
  }

  // Valori non disponibili in combinazione con le altre opzioni selezionate: barrati
  #markAvailability() {
    const selected = this.data.options.map((_, i) => this.querySelector(`input[data-option-index="${i}"]:checked`)?.value);
    this.querySelectorAll('[data-variant-picker] input[type="radio"]').forEach((input) => {
      const index = Number(input.dataset.optionIndex);
      const combo = [...selected];
      combo[index] = input.value;
      const available = this.data.variants.some((v) => v.available && v.options.every((o, i) => combo[i] === undefined || o === combo[i]));
      input.closest('label').classList.toggle('is-oos', !available);
    });
  }

  #isSizeIndex(index) {
    return this.#sizeInputs.some((i) => Number(i.dataset.optionIndex) === index);
  }

  #render() {
    const v = this.variant;
    const fmt = (c) => formatMoney(c, this.moneyFormat);
    const promo = hasPromo();
    const total = v.price * this.#qty;
    const promoTotal = Math.round(total / 2);
    const sale = v.compare_at_price > v.price;
    const discount = sale ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
    const saved = promo ? total - promoTotal : sale ? (v.compare_at_price - v.price) * this.#qty : 0;

    const discounted = promo || sale;
    this.querySelector('[data-price]').textContent = fmt(promo ? promoTotal : total);
    this.querySelector('[data-price]').classList.toggle('is-sale', discounted);
    this.querySelector('[data-sticky-price]').classList.toggle('is-sale', discounted);
    this.querySelector('[data-was]').textContent = promo ? fmt(total) : sale ? fmt(v.compare_at_price * this.#qty) : '';
    const disc = this.querySelector('[data-disc]');
    disc.hidden = !(promo || discount > 0);
    disc.textContent = promo ? '-50%' : `-${discount}%`;

    const low = this.sizeChosen && v.inventory !== null && v.inventory > 0 && v.inventory <= 5;
    this.querySelector('[data-low-stock]').hidden = !low;
    if (low) this.querySelector('[data-low-stock-text]').textContent = `Solo ${v.inventory} ${v.inventory === 1 ? 'pezzo rimasto' : 'pezzi rimasti'}`;

    const chosen = this.sizeChosen;
    const soldOut = chosen && !v.available;
    const add = this.querySelector('[data-add]');
    add.disabled = soldOut;
    add.classList.toggle('is-pending', !chosen);
    if (!add.classList.contains('is-added')) {
      this.querySelector('[data-add-label]').textContent = soldOut ? 'Esaurito' : !chosen ? 'Scegli la taglia' : promo ? 'Aggiungi a -50%' : 'Aggiungi al carrello';
    }
    const stickyAdd = this.querySelector('[data-sticky-add]');
    stickyAdd.disabled = soldOut;
    stickyAdd.classList.toggle('is-pending', !chosen);
    stickyAdd.textContent = soldOut ? 'Esaurito' : !chosen ? 'Scegli la taglia' : promo ? 'Aggiungi a -50%' : 'Aggiungi al carrello';
    this.querySelector('.nfr-buy-now')?.classList.toggle('is-locked', !chosen || soldOut);
    this.querySelector('[data-sticky-price]').textContent = fmt(promo ? promoTotal : total);
    const miniPrice = this.querySelector('[data-mini-price]');
    if (miniPrice) miniPrice.textContent = fmt(promo ? promoTotal : total);
    this.querySelector('[data-sticky-saving]').textContent = saved > 0 ? `-${fmt(saved)}` : '';
  }

  get #slides() {
    return [...this.querySelectorAll('.nfr-pdp__slide')];
  }

  #showMedia(mediaId, { smooth = false } = {}) {
    const slides = this.#slides;
    const slide = slides.find((s) => Number(s.dataset.mediaId) === mediaId);
    if (!slide) return;
    this.#markMedia(mediaId);
    const track = this.querySelector('[data-track]');
    track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'instant' });
  }

  // Aggiorna pallini, miniature, contatore e frecce senza muovere il carosello
  #markMedia(mediaId) {
    const slides = this.#slides;
    const index = slides.findIndex((s) => Number(s.dataset.mediaId) === mediaId);
    if (index < 0) return;
    this.mediaId = mediaId;
    slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
    this.querySelectorAll('[data-go]').forEach((b) => b.classList.toggle('is-on', Number(b.dataset.go) === mediaId));
    const count = this.querySelector('[data-count]');
    if (count) count.textContent = index + 1;
    const prev = this.querySelector('[data-step="-1"]');
    const next = this.querySelector('[data-step="1"]');
    const thumb = this.querySelector(`.nfr-pdp__thumb[data-go="${mediaId}"] img`);
    const mini = this.querySelector('[data-mini-img]');
    if (thumb && mini) mini.src = thumb.currentSrc || thumb.src;
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === slides.length - 1;
  }

  #stepMedia(delta) {
    const ids = this.#slides.map((s) => Number(s.dataset.mediaId));
    const next = ids.indexOf(this.mediaId ?? ids[0]) + delta;
    if (next >= 0 && next < ids.length) this.#showMedia(ids[next], { smooth: true });
  }

  #bindImageSwipe(signal) {
    const track = this.querySelector('[data-track]');
    const area = this.querySelector('[data-img-area]');
    const ids = this.#slides.map((s) => Number(s.dataset.mediaId));

    let frame;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        const id = ids[Math.min(ids.length - 1, Math.max(0, index))];
        if (id !== this.mediaId) this.#markMedia(id);
      });
    }, { passive: true, signal });

    this.querySelectorAll('[data-step]').forEach((btn) =>
      btn.addEventListener('click', () => this.#stepMedia(Number(btn.dataset.step)), { signal })
    );

    // Gesto verticale sulle foto: giù allarga le foto, su riapre i dettagli. Mai "tira per aggiornare".
    let g = null;
    area.addEventListener('touchstart', (e) => {
      g = { x: e.touches[0].clientX, y: e.touches[0].clientY, axis: null };
    }, { passive: true, signal });
    area.addEventListener('touchmove', (e) => {
      if (!g) return;
      const dx = e.touches[0].clientX - g.x;
      const dy = e.touches[0].clientY - g.y;
      if (!g.axis && Math.abs(dx) + Math.abs(dy) > 8) g.axis = Math.abs(dy) > Math.abs(dx) ? 'y' : 'x';
      if (g.axis === 'y' && e.cancelable) e.preventDefault();
    }, { passive: false, signal });
    area.addEventListener('touchend', (e) => {
      if (g?.axis === 'y' && isMobile()) {
        const dy = e.changedTouches[0].clientY - g.y;
        if (dy > 50 && !this.#collapsed) this.#setCollapsed(true);
        else if (dy < -50 && this.#collapsed) this.#setCollapsed(false);
      }
      g = null;
    }, { signal });

    this.#peekHint(track, ids.length);
  }

  // Solo la prima volta per sessione: le foto sbirciano di lato e compare "Scorri per altre foto"
  #peekHint(track, count) {
    const hint = this.querySelector('[data-swipe-hint]');
    if (!hint || count < 2) return;
    try {
      if (sessionStorage.getItem('nfr_swipe_hint')) return;
      sessionStorage.setItem('nfr_swipe_hint', '1');
    } catch {}
    const stop = () => {
      hint.classList.remove('is-on');
      track.classList.remove('is-peek');
    };
    setTimeout(() => {
      if (track.scrollLeft > 4) return;
      hint.classList.add('is-on');
      track.classList.add('is-peek');
      setTimeout(() => track.classList.remove('is-peek'), 1200);
      setTimeout(() => hint.classList.remove('is-on'), 2800);
    }, 900);
    track.addEventListener('scroll', stop, { once: true, passive: true });
  }

  // Il pannello segue il dito. Tre posizioni su mobile: chiuso (solo foto), a metà, espanso a tutto schermo.
  // Aperto a metà: su → si espande, giù → si chiude. Espanso: giù (dall'inizio del contenuto) → torna a metà.
  #bindPanelSwipe(signal) {
    const panel = this.panel;
    const PEEK = 64;
    let lastDragEnd = 0;

    panel.addEventListener('touchstart', (e) => {
      if (!isMobile()) return;
      this.#drag = {
        y: e.touches[0].clientY,
        t: performance.now(),
        dy: 0,
        mode: null,
        fromHandle: !!e.target.closest('[data-drag], [data-mini]'),
        atTop: panel.scrollTop <= 0,
        height: panel.offsetHeight,
        closed: panel.offsetHeight - PEEK,
        max: window.innerHeight - this.querySelector('[data-img-area]').getBoundingClientRect().top - 8,
      };
    }, { passive: true, signal });

    panel.addEventListener('touchmove', (e) => {
      const d = this.#drag;
      if (!d || d.mode === 'none') return;
      const dy = e.touches[0].clientY - d.y;
      if (!d.mode) {
        if (Math.abs(dy) < 6) return;
        const top = d.atTop || d.fromHandle;
        if (this.#collapsed) d.mode = 'open';
        else if (this.#expanded) d.mode = dy > 0 && top ? 'shrink' : 'none';
        else if (dy < 0) d.mode = 'grow';
        else d.mode = top ? 'collapse' : 'none';
        if (d.mode === 'none') return;
        d.y += dy > 0 ? 6 : -6;
        panel.classList.add('is-dragging');
      }
      if (e.cancelable) e.preventDefault();
      d.dy = e.touches[0].clientY - d.y;
      if (d.mode === 'open') panel.style.transform = `translateY(${Math.min(d.closed, Math.max(0, d.closed + d.dy))}px)`;
      else if (d.mode === 'collapse') panel.style.transform = `translateY(${Math.max(0, d.dy)}px)`;
      else panel.style.height = `${Math.min(d.max, Math.max(window.innerHeight * 0.4, d.height - d.dy))}px`;
    }, { passive: false, signal });

    const end = () => {
      const d = this.#drag;
      this.#drag = null;
      if (!d?.mode || d.mode === 'none') return;
      lastDragEnd = performance.now();
      const velocity = d.dy / Math.max(1, performance.now() - d.t);
      panel.classList.remove('is-dragging');
      panel.style.transform = '';
      panel.style.height = '';
      if (d.mode === 'collapse' && (d.dy > 90 || (velocity > 0.35 && d.dy > 30))) this.#setCollapsed(true);
      else if (d.mode === 'open' && (d.dy < -60 || (velocity < -0.35 && d.dy < -20))) this.#setCollapsed(false);
      else if (d.mode === 'grow' && (d.dy < -60 || (velocity < -0.35 && d.dy < -20))) this.#setExpanded(true);
      else if (d.mode === 'shrink' && (d.dy > 80 || (velocity > 0.35 && d.dy > 30))) this.#setExpanded(false);
    };
    panel.addEventListener('touchend', end, { signal });
    panel.addEventListener('touchcancel', end, { signal });

    // Il tocco sulla maniglia apre/chiude, ma non subito dopo un trascinamento
    this.querySelector('[data-drag]').addEventListener('click', (e) => {
      if (performance.now() - lastDragEnd < 400) e.stopImmediatePropagation();
    }, { capture: true, signal });

    const sticky = this.querySelector('[data-sticky]');
    let stickyY = null;
    sticky.addEventListener('touchstart', (e) => (stickyY = e.touches[0].clientY), { passive: true, signal });
    sticky.addEventListener('touchend', (e) => {
      if (stickyY !== null && e.changedTouches[0].clientY - stickyY < -30) this.#setCollapsed(false);
      stickyY = null;
    }, { signal });
  }

  // Porta il cliente alle taglie: riapre il pannello, scorre fino al gruppo e lo evidenzia
  #askSize() {
    const group = this.querySelector('[data-size-group]');
    if (!group) return;
    if (this.#collapsed) this.#setCollapsed(false);
    group.classList.remove('is-need');
    void group.offsetWidth;
    group.classList.add('is-need');
    const top = group.getBoundingClientRect().top - this.panel.getBoundingClientRect().top + this.panel.scrollTop - 16;
    this.panel.scrollTo({ top, behavior: 'smooth' });
  }

  // Barra fissa mobile: compare quando il pulsante del pannello esce dalla vista
  #bindSticky() {
    const form = this.querySelector('[data-form]');
    this.ctaVisible = true;
    this.observer = new IntersectionObserver(([entry]) => {
      this.ctaVisible = entry.isIntersecting;
      this.#updateSticky();
    }, { root: this.panel, threshold: 0.6 });
    this.observer.observe(form);
  }

  #updateSticky() {
    const show = this.#collapsed || !this.ctaVisible;
    this.classList.toggle('show-sticky', show);
    this.querySelector('[data-sticky]').setAttribute('aria-hidden', String(!show));
  }

  // L'acquisto rapido non deve partire senza taglia
  #guardBuyNow(signal) {
    const buyNow = this.querySelector('.nfr-buy-now');
    if (!buyNow) return;
    const block = (e) => {
      if (this.sizeChosen) return;
      e.preventDefault();
      e.stopPropagation();
      this.#askSize();
    };
    buyNow.addEventListener('click', block, { capture: true, signal });
    buyNow.addEventListener('submit', block, { capture: true, signal });
  }

  #setExpanded(value) {
    this.#expanded = value && isMobile();
    this.classList.toggle('is-expanded', this.#expanded);
    if (!this.#expanded) this.panel.scrollTop = 0;
  }

  #setCollapsed(value) {
    if (value) this.#setExpanded(false);
    this.#collapsed = value;
    this.classList.toggle('is-collapsed', value);
    if (value) this.panel.scrollTop = 0;
    this.#updateSticky();
  }

  async #add(event) {
    event?.preventDefault();
    if (!this.sizeChosen) {
      this.#askSize();
      return;
    }
    const v = this.variant;
    if (!v.available) return;
    const button = this.querySelector('[data-add]');
    const error = this.querySelector('[data-add-error]');
    error.hidden = true;

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
      .filter(Boolean);
    const body = new FormData();
    body.set('id', String(v.id));
    body.set('quantity', String(this.#qty));
    if (sectionIds.length) body.set('sections', sectionIds.join(','));

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(v.id), quantity: this.#qty }],
      promise: deferred.promise,
    }));

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', body, headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (response.status) throw new Error(response.description || response.message || 'Errore');
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'nfr-product', sourceId: this.dataset.sectionId, itemCount: this.#qty, productId: this.dataset.productId, sections: response.sections, didError: false },
      });
      button.classList.add('is-added');
      this.querySelector('[data-add-label]').textContent = 'Aggiunto ✓';
      setTimeout(() => {
        button.classList.remove('is-added');
        this.#render();
      }, 2000);
    } catch (err) {
      deferred.reject(err);
      this.dispatchEvent(new CartErrorEvent({ error: err.message, code: 'INVALID' }));
      error.textContent = err.message;
      error.hidden = false;
    }
  }

  // Scheda prodotto: dati estratti dalla descrizione (grammatura, materiale, vestibilità, lavorazioni, cura)
  #renderSpec() {
    const tpl = this.querySelector('template[data-description]');
    const holder = document.createElement('div');
    holder.innerHTML = tpl ? tpl.innerHTML : '';
    const html = holder.innerHTML;
    const text = holder.textContent.replace(/\s+/g, ' ').trim();
    const low = text.toLowerCase();

    // Intro di brand (es. Read Me: "Non è una grafica. È un messaggio.")
    const intro = text.match(/READ ME®?\s*(.+?\.)\s*(.+?\.)\s*(.+?\.)/);
    if (intro) {
      const el = this.querySelector('[data-spec-intro]');
      el.textContent = `${intro[1]} ${intro[2]} ${intro[3]}`;
      el.hidden = false;
    }

    const chips = [];
    const add = (icon, label, value) => chips.push({ icon, label, value });
    const gsm = low.match(/(\d{3})\s*(?:gr?m?s?|gsm|grammi|g\b)/);
    if (/policotone/.test(low) && /garzat/.test(low)) add('cotton', '100% cotone garzato', 'o policotone 65/35 invernale');
    else if (/pettinato/.test(low)) add('cotton', '100% cotone pettinato', /24\/1/.test(low) ? 'filato 24/1' : '');
    else if (/cotone/.test(low)) add('cotton', '100% cotone', '');
    if (gsm) add('weight', `${gsm[1]} g/m²`, Number(gsm[1]) >= 300 ? 'tessuto pesante' : Number(gsm[1]) >= 250 ? 'tessuto medio-pesante' : 'tessuto corposo');
    if (/italia|italy|italian/.test(low)) add('italy', 'Made in Italy', /artigian|a mano/.test(low) ? 'lavorato da artigiani' : '');
    if (/prelavat/.test(low)) add('wash', 'Prelavato', 'ritiro 0-3%');
    if (/doppie?\s*impunture|3 aghi/.test(low)) add('stitch', 'Cuciture rinforzate', /3 aghi/.test(low) ? '3 aghi' : 'doppie impunture');
    if (/garzatura|privo di pelo/.test(low)) add('fleece', 'Interno garzato', 'morbido, senza pelucchi');
    if (/cappuccio foderato/.test(low)) add('hood', 'Cappuccio foderato', '');
    if (/tasca frontale/.test(low)) add('pocket', 'Tasca frontale', '');
    const model = text.match(/modello è (\d+)\s*kg e alto (\d+)\s*cm e indossa la taglia:?\s*(\w+)/i);
    if (model) add('model', `Il modello indossa ${model[3]}`, `${model[2]} cm · ${model[1]} kg`);
    this.querySelector('[data-spec-chips]').innerHTML = chips
      .map((c) => `<div class="nfr-chip">${svg(c.icon)}<div><strong>${c.label}</strong>${c.value ? `<span>${c.value}</span>` : ''}</div></div>`)
      .join('');

    // Vestibilità
    const fit = /wide fit|balloon|baloon/.test(low) ? 'wide' : /boxy/.test(low) ? 'boxy' : /oversiz/.test(low) ? 'oversized' : /regular/.test(low) ? 'regular' : /slim/.test(low) ? 'slim' : null;
    if (fit) {
      const box = this.querySelector('[data-fit]');
      box.hidden = false;
      this.querySelector('[data-fit-name]').textContent = { slim: 'Slim', regular: 'Regular', boxy: 'Boxy fit', oversized: 'Oversize', wide: 'Wide fit' }[fit];
      this.querySelector('[data-fit-marker]').style.setProperty('--pos', FIT_POS[fit] / 3);
      this.querySelector('[data-fit-note]').textContent = FIT_NOTE[fit];
      this.querySelector('[data-fit-track]').setAttribute('aria-label', `Vestibilità: ${fit}`);
    }

    // Cura del capo
    const care = [];
    if (/30\s*°|30 gradi/.test(low)) care.push(['t30', 'Lavaggio max 30°']);
    if (/rovesci/.test(low)) care.push(['inside', 'Lava al rovescio']);
    if (/asciugatrice/.test(low)) care.push(['nodry', 'No asciugatrice']);
    if (care.length) care.push(['noiron', 'Non stirare la stampa']);
    if (care.length) {
      this.querySelector('[data-care]').hidden = false;
      this.querySelector('[data-care-list]').innerHTML = care.map(([i, l]) => `<li>${svg(i)}<span>${l}</span></li>`).join('');
    }

    // Guida taglie: tabella HTML presente nella descrizione oppure tabella nota dall'immagine
    let chart = null;
    for (const [key, data] of Object.entries(SIZE_CHARTS)) if (html.includes(key)) chart = data;
    const table = holder.querySelector('table');
    if (!chart && table) {
      const rows = [...table.querySelectorAll('tr')].map((tr) => [...tr.children].map((c) => c.textContent.trim()));
      const head = rows.shift();
      if (head && rows.length) {
        chart = { sizes: rows.map((r) => r[0]), rows: head.slice(1).map((h, i) => [h.replace(/^[A-Z]\s*[–—-]\s*/, '').replace(/\(cm\)/i, '').trim(), rows.map((r) => Number(r[i + 1]) || r[i + 1])]) };
      }
    }
    if (chart) {
      this.chart = chart;
      this.querySelector('[data-size-guide]').hidden = false;
      this.querySelectorAll('[data-open-guide]').forEach((b) => (b.hidden = false));
      this.querySelector('[data-sg-table]').innerHTML =
        `<thead><tr><th scope="col">Taglia</th>${chart.sizes.map((z) => `<th scope="col" data-size="${z}">${z}</th>`).join('')}</tr></thead>` +
        `<tbody>${chart.rows.map(([name, vals]) => `<tr><th scope="row">${name}</th>${vals.map((v, i) => `<td data-size="${chart.sizes[i]}">${v}</td>`).join('')}</tr>`).join('')}</tbody>`;
      this.#highlightSize();
    }

    // Descrizione pulita: niente immagini/tabelle (già mostrate), niente stili inline, maiuscole urlate rese leggibili
    holder.querySelectorAll('img, table, hr, style, script, h3, h4').forEach((n) => n.remove());
    holder.querySelectorAll('[style], [class], [data-mce-fragment], [data-mce-style]').forEach((n) => {
      n.removeAttribute('style'); n.removeAttribute('class'); n.removeAttribute('data-mce-fragment'); n.removeAttribute('data-mce-style');
    });
    holder.querySelectorAll('p, span, strong, em, li, div').forEach((n) => {
      for (const t of n.childNodes) {
        if (t.nodeType === 3 && t.textContent.length > 12 && t.textContent === t.textContent.toUpperCase() && /[A-Z]{4}/.test(t.textContent)) {
          const lower = t.textContent.toLowerCase();
          t.textContent = lower.charAt(0).toUpperCase() + lower.slice(1);
        }
      }
    });
    holder.querySelectorAll('p, div, span').forEach((n) => { if (!n.textContent.trim() && !n.querySelector('br')) n.remove(); });
    this.querySelector('[data-description-clean]').innerHTML = holder.innerHTML;
  }

  #highlightSize() {
    if (!this.chart) return;
    const sizeIndex = this.data.options.findIndex((o) => /tagli|size/i.test(o));
    const size = sizeIndex >= 0 ? this.variant.options[sizeIndex] : null;
    this.querySelectorAll('[data-sg-table] [data-size]').forEach((c) => c.classList.toggle('is-on', c.dataset.size === size));
    const col = this.chart.sizes.indexOf(size);
    this.querySelector('[data-sg-mine]').innerHTML = col >= 0
      ? `<span>La tua <strong>${size}</strong></span>${this.chart.rows.map(([n, v]) => `<span><em>${n}</em><b>${v[col]} cm</b></span>`).join('')}`
      : '';
  }

  async #loadRecommendations(signal) {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const res = await fetch(`${root}recommendations/products.json?product_id=${this.dataset.productId}&limit=8`, { signal });
      const { products = [] } = await res.json();
      if (!products.length) return;
      const strip = this.querySelector('[data-cross-strip]');
      const fmt = (c) => formatMoney(c, this.moneyFormat);
      for (const p of products) {
        const a = document.createElement('a');
        a.className = 'nfr-cs-card';
        a.href = p.url;
        const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=300` : '';
        a.innerHTML = `
          <div class="nfr-cs-img">
            ${img ? `<img src="${img}" alt="" loading="lazy" width="130" height="130">` : ''}
            <span class="nfr-cs-badge nfr-when-cart">-50%</span>
            <div class="nfr-cs-price">
              <span class="nfr-cs-price__now nfr-when-empty">${fmt(p.price)}</span>
              <span class="nfr-cs-price__now is-sale nfr-when-cart">${fmt(Math.round(p.price / 2))}</span>
              <span class="nfr-cs-price__was nfr-when-cart">${fmt(p.price)}</span>
            </div>
          </div>
          <div class="nfr-cs-name"></div>`;
        a.querySelector('.nfr-cs-name').textContent = p.title;
        strip.append(a);
      }
      this.querySelector('[data-cross]').hidden = false;
    } catch {}
  }
}

if (!customElements.get('nfr-product')) customElements.define('nfr-product', NfrProduct);
